
import { useEffect } from "react";
import { Header } from "@/components/Header";
import { Footer } from "@/components/Footer";
import { useNavigate } from "react-router-dom";

const Disclaimer = () => {
  const navigate = useNavigate();

  useEffect(() => {
    // Update SEO meta tags for disclaimer page
    document.title = "Disclaimer | VakantieUitzoeken.com - Voorwaarden en aansprakelijkheid";
    
    const metaDescription = document.querySelector('meta[name="description"]');
    if (metaDescription) {
      metaDescription.setAttribute('content', 'Lees onze disclaimer betreffende de informatie op VakantieUitzoeken.com. Voorwaarden, aansprakelijkheid en copyright informatie.');
    }
    
    const metaKeywords = document.querySelector('meta[name="keywords"]');
    if (metaKeywords) {
      metaKeywords.setAttribute('content', 'disclaimer, voorwaarden, aansprakelijkheid, copyright, reisvoorwaarden');
    }
  }, []);

  // Header navigation handlers
  const handleShowAllVacations = () => navigate('/alle-vakanties');
  const handleShowDeals = () => navigate('/deals');
  const handleShowLuxury = () => navigate('/luxe');
  const handleShowRondreizen = () => navigate('/rondreizen');
  const handleShowThema = () => navigate('/thema');
  const handleShowFavoritesComparison = () => navigate('/favorieten-vergelijken');
  const handleGoHome = () => navigate('/');

  return (
    <div className="min-h-screen bg-gradient-to-br from-amber-50 via-orange-50 to-yellow-50 flex flex-col">
      <Header 
        onShowAllVacations={handleShowAllVacations}
        onShowDeals={handleShowDeals}
        onShowLuxury={handleShowLuxury}
        onShowRondreizen={handleShowRondreizen}
        onShowThema={handleShowThema}
        onShowFavoritesComparison={handleShowFavoritesComparison}
        onGoHome={handleGoHome}
        currentView="disclaimer"
      />
      
      <main className="flex-1">
        <div className="container mx-auto px-4 py-8">
          <div className="max-w-4xl mx-auto prose prose-lg">
            <h1 className="text-3xl md:text-4xl font-bold text-orange-600 mb-6">
              Disclaimer VakantieUitzoeken.com
            </h1>
            
            <div className="space-y-6 text-gray-700">
              <section>
                <p>
                  De informatie op deze website is met grote zorg samengesteld door de redactie. Ondanks dit is het mogelijk dat de informatie die hier wordt gepubliceerd onvolledig of onjuist is of fouten kan bevatten. Wij hebben geen achtergrond in de vakantiebranche, maar ons team bestaat uit redacteuren en webbouwers. Hoewel wij onze uiterste best doen om alle informatie, diensten en producten zo goed en foutloos mogelijk aan te bieden, kunnen wij niet verantwoordelijk gesteld worden voor eventuele fouten, defects of andere beschadigende consequenties, voortkomend uit het gebruik van deze website of het aanklikken van links naar websites van derden. VakantieUitzoeken.com ziet derhalve af van welke aansprakelijkheid dan ook.
                </p>
              </section>

              <section>
                <p>
                  De informatie op deze website is uitsluitend bedoeld als algemene informatie en voor algemeen gebruik. Er kunnen geen rechten aan de informatie op onze website worden ontleend.
                </p>
              </section>

              <section>
                <p>
                  Er bevinden zich affiliate-items op de site, vooral gepresenteerd als productinformatie, maar dat kan ook in de vorm van advertorials en advertenties zijn. De redactie is niet verantwoordelijk voor de producten en websites waar zij naar verwijst in deze items.
                </p>
              </section>

              <section>
                <h2 className="text-2xl font-semibold text-gray-800 mb-3">Cookies en privacy</h2>
                <p>
                  Wanneer u onze website bezoekt, kunnen services van derden algemene en niet-persoonlijke informatie over u verzamelen. De verzameling van deze niet-persoonlijke gegevens gebeurt ofwel door de cookie technologie of met webbeacons. De cookies slaan geen persoonlijke informatie op zoals uw naam of emailadres. Als u onze website bekijkt, kunnen wij bepaalde informatie op uw computer opslaan.
                </p>
                <p>
                  U kunt het gebruik van cookies weigeren door in uw browser de daarvoor geëigende instellingen te kiezen. Door gebruik te maken van deze website geeft u toestemming voor het verwerken van de informatie door deze partijen op de wijze en voor de doeleinden zoals hiervoor omschreven.
                </p>
              </section>

              <section>
                <h2 className="text-2xl font-semibold text-gray-800 mb-3">Copyright</h2>
                <p>
                  Het kan voorkomen dat, ondanks onze zorgvuldigheid en oprechte bedoelingen, een copyright-houder toch meent dat zijn/haar belangen worden geschaad. In zo'n voorkomend geval verzoeken we u om contact met ons op te nemen. Indien uw bezwaar redelijk / begrijpelijk is zullen wij zo snel mogelijk de betreffende informatie verwijderen.
                </p>
              </section>

              <section>
                <h2 className="text-2xl font-semibold text-gray-800 mb-3">Reisvoorwaarden</h2>
                <p>
                  Voor alle door ons aangeboden reizen gelden de algemene voorwaarden van de betreffende reisorganisatie of touroperator. Deze voorwaarden zijn beschikbaar op aanvraag of via de website van de betreffende partner.
                </p>
              </section>

              <section>
                <h2 className="text-2xl font-semibold text-gray-800 mb-3">Contact</h2>
                <p>
                  Voor vragen over deze disclaimer kunt u contact met ons opnemen:
                </p>
                <p>
                  E-mail: administratie@y-catcher.nl<br />
                  Telefoon: +31 75 6401793<br />
                  Adres: Laboratoriumweg 6A, 1525 RA Westknollendam
                </p>
              </section>

              <p className="text-sm text-gray-600 mt-8">
                Laatst bijgewerkt: {new Date().toLocaleDateString('nl-NL')}
              </p>
            </div>
          </div>
        </div>
      </main>
      
      <Footer />
    </div>
  );
};

export default Disclaimer;
